// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__OppSi","cbx":"Checkbox_cbx__SFgNG","inp-cbx":"Checkbox_inp-cbx__VeWuk","wave":"Checkbox_wave__vfR4r","inline-svg":"Checkbox_inline-svg__WkBaz"};